export const updates = [
  {
    id: "u1",
    title: "长风渡月",
    info: "更新至 32 集",
    type: "剧集",
    quality: "蓝光4K",
    time: "刚刚",
  },
  {
    id: "u2",
    title: "雾港迷案",
    info: "更新至 18 集",
    type: "剧集",
    quality: "1080P",
    time: "12 分钟前",
  },
  {
    id: "u3",
    title: "星野食堂",
    info: "更新第 9 期",
    type: "综艺",
    quality: "HD高清",
    time: "26 分钟前",
  },
  {
    id: "u4",
    title: "山海拾遗录",
    info: "更新至 12 集",
    type: "动漫",
    quality: "蓝光4K",
    time: "40 分钟前",
  },
  {
    id: "u5",
    title: "归途信号",
    info: "全 16 集上线",
    type: "剧集",
    quality: "蓝光4K",
    time: "1 小时前",
  },
  {
    id: "u6",
    title: "雪线之上",
    info: "4K 重制版上线",
    type: "电影",
    quality: "蓝光4K",
    time: "2 小时前",
  },
  {
    id: "u7",
    title: "城市脉搏",
    info: "全 8 集 补档",
    type: "纪录片",
    quality: "1080P",
    time: "3 小时前",
  },
  {
    id: "u8",
    title: "茶馆轶事",
    info: "高清修复版上线",
    type: "电影",
    quality: "1080P",
    time: "今天 08:20",
  },
];